import { render, staticRenderFns } from "./recordedInfo.vue?vue&type=template&id=38f0fde8&scoped=true"
import script from "./recordedInfo.vue?vue&type=script&lang=js"
export * from "./recordedInfo.vue?vue&type=script&lang=js"
import style0 from "./recordedInfo.vue?vue&type=style&index=0&id=38f0fde8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0fde8",
  null
  
)

export default component.exports